import http from '../clients/Axios'

export default class PaymentService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          if (el === 'ctg' || el === 'name') {
            filters_param =
              filters_param + '&' + el + '=' + filters[el].value.trim()
          } else {
            filters_param = filters_param + '&' + el + '=' + filters[el].value
          }
        }
      })
    }

    const res = await http.get(
      `/payment_method/paginate?page=${pageNumber}&size=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get() {
    const res = await http.get('/payment_method?sort=name')
    return res.data
  }

  async getById(param) {
    param = param ? param : ''
    const res = await http.get(`/payment_method${param}`)
    return res
  }

  async add(form) {
    const res = await http.post('/payment_method', form)
    return res
  }

  async update(id, form) {
    const res = await http.put(`/payment_method/${id}`, form)
    return res
  }

  async delete(id) {
    const res = await http.delete(`/payment_method/${id}`)
    return res
  }
}
